import React from 'react';
import { classNames } from 'tradera/utils/class-names';

import styles from './divider.module.scss';

import type * as Polymorphic from './polymorphic';

type DividerProps = { dark?: boolean };

export const Divider = React.forwardRef(function Divider(
    { as, dark = false, className, children, ...props },
    forwardRef
) {
    const Component = as ?? (children ? 'div' : 'hr');
    const role = Component !== 'hr' ? 'separator' : undefined;

    return (
        <Component
            className={classNames(
                styles.component,
                dark && styles.dark,
                className
            )}
            ref={forwardRef}
            role={role}
            {...props}>
            {children ? (
                <span className="d-inline-block px-2">{children}</span>
            ) : null}
        </Component>
    );
}) as Polymorphic.ForwardRefComponent<'hr', DividerProps>;
